export default __webpack_public_path__ + "static/logo-491ec7854d698141f3a393ab0c9836e3.svg";